import { Component } from '@angular/core';

@Component({
  selector: 'konnect-device-hardware',
  standalone: true,
  imports: [],
  templateUrl: './konnect-device-hardware.component.html',
  styleUrl: './konnect-device-hardware.component.scss'
})
export class KonnectDeviceHardwareComponent {

}
